export const login = {
    header: "Login",
    items: {
        username: {
            placeholder: "Enter Username",
            label: "Username",
            type: "text",
        },
        password: {
            placeholder: "Enter Password",
            label: "Password",
            type: "password",
        },
    },
    submit: {
        placeholder: "Submit",
        label: "Submit",
        type: "submit",
    },
    cancel: {
        label: "Cancel",
    },
};
